<h1 mat-dialog-content>{{ message | translate }}</h1>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button color="primary" mat-dialog-close tabindex="-1" (click)="onConfirm()">{{ 'Close' | translate }}</button>
</div>
